import { userStore } from '@components/store';
export const createNftImageLocation = (positionId: number) => {
  const networkID = userStore.getState().networkID;
  if (networkID === '1') {
    return 'https://s3.us-west-2.amazonaws.com/archimedesfi-nft-images-v1.0/' + positionId + '.png';
  } else {
    return '/example-nft.png';
  }
};
